var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.3,
    fill: "#5d78ff",
    d: "M6.667,10.5h6.667A1.667,1.667,0,0,0,15,8.833V8h1.667v.833a3.333,3.333,0,0,1-3.333,3.333H6.667v1.667a.833.833,0,0,1-1.667,0v-5a.833.833,0,0,1,1.667,0Z",
    transform: "translate(-0.833 -1.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M5.333,20a1.667,1.667,0,1,0-1.667-1.667A1.667,1.667,0,0,0,5.333,20Zm0,1.667a3.333,3.333,0,1,1,3.333-3.333A3.333,3.333,0,0,1,5.333,21.667Z",
    transform: "translate(-0.333 -2.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M17.333,6a1.667,1.667,0,1,0-1.667-1.667A1.667,1.667,0,0,0,17.333,6Zm0,1.667a3.333,3.333,0,1,1,3.333-3.333A3.333,3.333,0,0,1,17.333,7.667Z",
    transform: "translate(-2.333 -0.167)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M5.333,6A1.667,1.667,0,1,0,3.667,4.333,1.667,1.667,0,0,0,5.333,6Zm0,1.667A3.333,3.333,0,1,1,8.667,4.333,3.333,3.333,0,0,1,5.333,7.667Z",
    transform: "translate(-0.333 -0.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.ebecc824a7aae0d5e89d3c38d4da8ff2.svg";
export { ForwardRef as ReactComponent };